import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { logout } from "@tailormed/common-client/services/auth";
import { CoreTopBar } from "@tailormed/common-client/component/AppShell";
import { ReactComponent as SignOutIcon } from "@tailormed/common-client/assets/svg/icon-menu-logout.svg";

import { selectUser, selectIDPConfig } from "../store/selector";
import { oktaConfig } from "../constant/okta";
import { INSIGHTS_BRAND } from "../constant/colors";

/* Insights top bar — avatar + Sign Out only (no Tasks / Notifications / search). */
const MainHeader = () => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const idpConfig = useSelector(selectIDPConfig);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSignOut = useCallback(() => {
    logout(user, idpConfig, oktaConfig.loginURI);
  }, [user, idpConfig]);

  return (
    <CoreTopBar
      avatar={{
        initials: `${user ? user.firstName?.substring(0, 1) : ""} ${user ? user.lastName?.substring(0, 1) : ""}`,
        color: INSIGHTS_BRAND,
        isAuthenticated: Boolean(user),
        open: menuOpen,
        onOpenChange: setMenuOpen,
        menuItems: [
          {
            key: "logout",
            id: "sign_out",
            icon: <SignOutIcon />,
            label: t("sidebar_menu.sign_out"),
            onClick: handleSignOut
          }
        ]
      }}
    />
  );
};

export { MainHeader };
